import { OriginApp, WidgetTheme } from '@wix/wix-help-widget-common/types';

const WIDGET_THEMES: readonly WidgetTheme[] = ['default', 'studio', 'odeditor', 'odeditor-dark', 'wixel'];

// `theme` reaches the widget as an iframe query param, so it is untrusted input.
export const isWidgetTheme = (value: unknown): value is WidgetTheme =>
  typeof value === 'string' && (WIDGET_THEMES as readonly string[]).includes(value);

// Theme implied by the host surface, for hosts that declare no `theme`.
export const originToTheme = (originApp: string | null): WidgetTheme => {
  if (originApp === OriginApp.Studio2Editor) {
    return 'odeditor-dark';
  }
  if (originApp === OriginApp.StudioEditor || originApp === OriginApp.Blocks) {
    return 'studio';
  }
  if (originApp === OriginApp.Editor3) {
    return 'odeditor';
  }
  return 'default';
};

/**
 * Resolves the theme once, at the point the widget app boots: a theme the host
 * declared wins, otherwise fall back to the one its origin implies. Everything
 * downstream takes the resolved `WidgetTheme`, never the origin.
 */
export const getWidgetTheme = (originApp: string | null, theme?: unknown): WidgetTheme =>
  isWidgetTheme(theme) ? theme : originToTheme(originApp);
